import { FC, SVGProps } from "react";

const RIStartLogo: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg width="37" height="22" viewBox="0 0 37 22" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M0.75 1.48107C8.35 -1.05227 13.4167 4.0144 18.4833 1.48107C23.55 -1.05227 28.6167 4.0144 36.2167 1.48107" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M0.75 5.28112C8.35 2.74778 13.4167 7.81445 18.4833 5.28112C23.55 2.74778 28.6167 7.81445 36.2167 5.28112" stroke="currentColor" strokeOpacity="0.8" strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M0.75 9.08116C8.35 6.54783 13.4167 11.6145 18.4833 9.08116C23.55 6.54783 28.6167 11.6145 36.2167 9.08116" stroke="currentColor" strokeOpacity="0.7" strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M0.75 12.881C8.35 10.3476 13.4167 15.4143 18.4833 12.881C23.55 10.3476 28.6167 15.4143 36.2167 12.881" stroke="currentColor" strokeOpacity="0.6" strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M0.75 16.681C8.35 14.1477 13.4167 19.2144 18.4833 16.681C23.55 14.1477 28.6167 19.2144 36.2167 16.681" stroke="currentColor" strokeOpacity="0.5" strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M0.75 20.4811C8.35 17.9477 13.4167 23.0144 18.4833 20.4811C23.55 17.9477 28.6167 23.0144 36.2167 20.4811" stroke="currentColor" strokeOpacity="0.4" strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

export default RIStartLogo;



